class WebSocketManager {

  RELATORIOS_ICON = 'fa-solid fa-file-arrow-down fa-lg';
  RELATORIOS_TITLE = 'Relatórios';
  RELATORIOS_HISTORICO_TITLE = 'Baixar Relatórios';

  CHANNELS = {
    'relatorios': this.processaNotificacaoRelatorio
  };

  constructor(url) {
    this.url = url;
    this.websocket = null;

    this.pingInterval = null;
    this.reconnectTimeout = null;
    this.reconnectDelay = 3000; // 3 segundos base
    this.maxReconnectDelay = 30000; // máximo 30s

    this.activeChannels = new Map();  // mantém canais após reconectar

    this.onmessage = this.onmessage.bind(this);
  }

  connect(afterOpen = null) {
    console.log(`Conectando WebSocket: ${this.url}`);

    try {
      this.websocket = new WebSocket(this.url);
    } catch (e) {
      console.error("Falha ao criar WebSocket:", e);
      return this.scheduleReconnect();
    }

    this.websocket.onopen = () => this.onopen(afterOpen);
    this.websocket.onmessage = this.onmessage;
    this.websocket.onerror = (e) => this.handleError(e);
    this.websocket.onclose = () => this.scheduleReconnect();
  }

  isConnectionActive() {
    return this.websocket != null && this.websocket.readyState === WebSocket.OPEN;
  }

  onopen(afterOpen) {
    console.log("WebSocket conectado!");

    // reset do retry
    this.reconnectDelay = 3000;

    if (afterOpen) afterOpen();

    // reentrar nos canais ativos
    this.restoreChannels();

    // iniciar heartbeat
    this.startPing();
  }

  startPing() {
    if (this.pingInterval) clearInterval(this.pingInterval);

    this.pingInterval = setInterval(() => {
      if (this.isConnectionActive()) {
        this.sendMessage({ type: "PING" });
      }
    }, 25000); // 25s (ideal pra evitar timeout em proxies NGINX)
  }

  scheduleReconnect() {
    if (this.reconnectTimeout) return;

    console.warn("WebSocket desconectado. Tentando reconectar...");

    this.reconnectTimeout = setTimeout(() => {
      this.reconnectTimeout = null;

      this.reconnectDelay = Math.min(
        this.reconnectDelay + 3000,
        this.maxReconnectDelay
      );

      this.connect();

    }, this.reconnectDelay);
  }

  conectaCanal(channelName, filtros = []) {
    const msg = { type: 'ENTER', channelName, filters: filtros };

    this.activeChannels.set(channelName, msg);

    if (!this.isConnectionActive()) {
      console.log("Socket fechado — reconectando antes de entrar no canal...");
      this.connect(() => this.sendMessage(msg));
    } else {
      this.sendMessage(msg);
    }
  }

  restoreChannels() {
    for (const [name, msg] of this.activeChannels.entries()) {
      console.log(`Reentrando no canal: ${name}`);
      this.sendMessage(msg);
    }
  }

  onmessage(event) {
    try {
      const body = JSON.parse(event.data);

      // heartbeat
      if (body.type === "PONG") return;

      if (!body.payload) return;

      const payload = JSON.parse(body.payload);
      const processChannel = this.CHANNELS[body.channelName];

      if (processChannel) {
        processChannel.call(this, payload);
      }
    } catch (error) {
      console.error("Erro ao processar mensagem do WebSocket:", error);
    }
  }

  handleError(error) {
    console.error("Erro no WebSocket:", error);
  }

  sendMessage(message) {
    if (this.isConnectionActive()) {
      this.websocket.send(JSON.stringify(message));
      return;
    }

    // Se não está conectado, reconectar e enviar depois
    console.warn("WebSocket fechado — reconectando para enviar mensagem...");

    this.connect(() => {
      if (this.isConnectionActive()) {
        this.websocket.send(JSON.stringify(message));
      }
    });
  }

  processaNotificacaoRelatorio(payload) {
    const { type, executionId, content, link, progress, tituloRelatorio, dataHoraFim, nomeUsuario, extensaoArquivo } = payload;

    const existing = document.getElementById(executionId);
    if (existing && existing.getAttribute('data-closed') === '1') {
      return;
    }

    switch(type) {
      case 'start':
        NotificationProvider.showToast(
          executionId,
          this.RELATORIOS_TITLE,
          content,
          null,
          null,
          this.RELATORIOS_ICON,
          tituloRelatorio,
          dataHoraFim,
          nomeUsuario
        );
        break;
      case 'progress':
        NotificationProvider.showToast(
          executionId,
          this.RELATORIOS_TITLE,
          content,
          parseInt(progress),
          null,
          this.RELATORIOS_ICON
        );
        break;
      case 'end':
        NotificationProvider.showToast(
          executionId,
          this.RELATORIOS_TITLE,
          content,
          null,
          link,
          this.RELATORIOS_ICON,
          tituloRelatorio,
          dataHoraFim,
          nomeUsuario,
          extensaoArquivo
        );
        break;
      case 'error':
        NotificationProvider.showToast(
          executionId,
          this.RELATORIOS_TITLE,
          content,
          null,
          null,
          this.RELATORIOS_ICON
        );
        break;
        case 'historicorelatorios':
          NotificationProvider.showToastModalHistorico(
            'historicorelatorios',
            this.RELATORIOS_HISTORICO_TITLE,
            content
          );
        break;
        case 'updatehistoricorelatorios':
          NotificationProvider.updateToastModalHistorico(
            'historicorelatorios',
            this.RELATORIOS_HISTORICO_TITLE,
            content,
            true
          );
        break;
      default:
        console.warn(`Tipo de notificação desconhecido: ${type}`);
    }
  }
}
